import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import configureStore from './configureStore'

import App from './containers/App'

const Dropin = ({
  onUploadSuccess,
  wptAppUrl,
  wptApiUrl,
  headingText,
  subheadingText,
  theme,
  cfeAuth,
  cfeApiUrl,
  onCfeAuthUpdate,
}) => {
  const store = configureStore({
    theme,
    wptApiUrl,
    wptAppUrl,
    onUploadSuccess,
    cfeAuth,
    cfeApiUrl,
    onCfeAuthUpdate,
  })

  const props = {
    theme,
    headingText,
    subheadingText,
    cfeAuth,
  }

  return (
    <Provider store={store}>
      <App {...props} />
    </Provider>
  )
}

Dropin.displayName = 'UploadWidget'
export default Dropin

function appUrlOrUploadSuccessIsRequired(props, propName, componentName) {
  const first = "Only one of props 'onUploadSuccess: func' or 'wptAppUrl: string' must be defined."
  // eslint-disable-next-line max-len
  const last = 'If you need a hard redirect, pass `wptAppUrl`, if you want a custom transition pass `onUploadSuccess`.'

  if (!(props.onUploadSuccess || props.wptAppUrl)) {
    return new Error(`${first} Neither prop is defined.\n${last}`)
  } else if (props.onUploadSuccess && props.wptAppUrl) {
    const msg = `${first} Both props are defined.\n${last}`
    return new Error(msg)
  }
  return PropTypes.checkPropTypes(
    {
      ...Dropin.propTypes,
      onUploadSuccess: PropTypes.func,
      wptAppUrl: PropTypes.string,
    },
    props,
    propName,
    componentName
  )
}

function wbeOnly(props, propName, componentName) {
  if (!props.cfeAuth && props[propName]) throw new Error(`Please remove ${propName} if not using cfeAuth`)

  const checkPropTypes = PropTypes.checkPropTypes(
    {
      ...Dropin.propTypes,
      onUploadSuccess: PropTypes.func,
      wptAppUrl: PropTypes.string,
      cfeApiUrl: PropTypes.string,
      onCfeAuthUpdate: PropTypes.func,
    },
    props,
    propName,
    componentName
  )

  if (propName === 'cfeApiUrl') return checkPropTypes

  return checkPropTypes
}
Dropin.propTypes = {
  theme: PropTypes.oneOf(['bibme', 'citationmachine', 'easybib', 'wfe']),
  cfeAuth: PropTypes.bool,
  wptApiUrl: PropTypes.string.isRequired,
  headingText: PropTypes.string,
  subheadingText: PropTypes.string,
  /* eslint-disable react/require-default-props */
  onUploadSuccess: appUrlOrUploadSuccessIsRequired,
  wptAppUrl: appUrlOrUploadSuccessIsRequired,
  cfeApiUrl: wbeOnly,
  onCfeAuthUpdate: wbeOnly,
  /* eslint-enable */
}

Dropin.defaultProps = {
  theme: 'bibme',
  headingText: "You didn't provide a headingText prop, is that on purpose?",
  subheadingText: "You didn't provide a subheadingText prop - is that on porpoise?",
  // Based on WBE Auth key, use Auth Scheme from CFE
  cfeAuth: false,
}
